import type { Tag, PriceLevel } from "@shared/types";

export interface FilterState {
  category?: string;
  styleDirection?: string;
  priceLevel?: PriceLevel | "";
  fresh?: "week";
  sort?: string;
}

interface Props {
  categories: Tag[];
  styles: Tag[];
  value: FilterState;
  onChange: (next: FilterState) => void;
}

export function FilterPanel({ categories, styles, value, onChange }: Props) {
  const update = (patch: Partial<FilterState>) => onChange({ ...value, ...patch });

  return (
    <div className="filter-bar">
      <select value={value.category ?? ""} onChange={(e) => update({ category: e.target.value || undefined })} aria-label="Category">
        <option value="">All categories</option>
        {categories.map((c) => (
          <option key={c.id} value={c.slug}>
            {c.brandCount == null ? c.name : `${c.name} (${c.brandCount})`}
          </option>
        ))}
      </select>

      <select value={value.styleDirection ?? ""} onChange={(e) => update({ styleDirection: e.target.value || undefined })} aria-label="Style direction">
        <option value="">All style directions</option>
        {styles.map((s) => (
          <option key={s.id} value={s.slug}>
            {s.brandCount == null ? s.name : `${s.name} (${s.brandCount})`}
          </option>
        ))}
      </select>

      <select value={value.priceLevel ?? ""} onChange={(e) => update({ priceLevel: (e.target.value || undefined) as PriceLevel | undefined })} aria-label="Price level">
        <option value="">Any price level</option>
        <option value="budget">Budget</option>
        <option value="accessible">Accessible</option>
        <option value="mid">Mid</option>
        <option value="mid-premium">Mid-premium</option>
        <option value="premium">Premium</option>
        <option value="luxury">Luxury</option>
      </select>

      <button
        type="button"
        className={`filter-toggle${value.fresh === "week" ? " is-active" : ""}`}
        onClick={() => update({ fresh: value.fresh === "week" ? undefined : "week" })}
        aria-pressed={value.fresh === "week"}
      >
        New this week
      </button>

      <select value={value.sort ?? "crowd"} onChange={(e) => update({ sort: e.target.value })} aria-label="Sort">
        <option value="crowd">Sort: Crowd signal</option>
        <option value="discovery">Sort: Discovery</option>
        <option value="momentum">Sort: Momentum</option>
        <option value="recent">Sort: Recently added</option>
        <option value="name">Sort: Name</option>
      </select>
    </div>
  );
}
